let currentSlideGridHomeSlider = 0;
let prevHomeSlider = document.querySelector(".prev-slide");
let nextHomeSlider = document.querySelector(".next-slide");

let isAnimating = false; // Флаг для блокировки анимации

function showSlide(index) {
  if (isAnimating) return; // Блокируем вызов, пока идет анимация
  isAnimating = true;

  const slides = document.querySelector(".slider-home-page__slider");
  if (!slides) {
    console.error("Slider not found");
    isAnimating = false;
    return;
  }

  currentSlideGridHomeSlider = 
    (index + slides.childElementCount) % slides.childElementCount;
  const translateValue = -currentSlideGridHomeSlider * 100 + "%";
  slides.style.transform = "translateX(" + translateValue + ")";

  // Обновляем точки
  updateDots(currentSlideGridHomeSlider);

  // Снимаем блокировку после завершения анимации (предположим, что она длится 500 мс)
  setTimeout(() => {
    isAnimating = false;
  }, 500);
}

function changeSlide(event, direction) {
  event.preventDefault();
  showSlide(currentSlideGridHomeSlider + direction);
}

function changeSlideAuto(direction) {
  showSlide(currentSlideGridHomeSlider + direction);
}

document.addEventListener("DOMContentLoaded", () => {
  showSlide(0); // Инициализируем первый слайд
  updateDots(0); // Инициализируем активную точку при загрузке
});

// Автоматическая смена слайдов каждые 10 секунд
setInterval(function () {
  changeSlideAuto(1);
}, 10000);

function currentSlide(index) {
  showSlide(index);
  updateDots(index);
}

// Логика для свайпов
let touchstartX = 0;
let touchendX = 0;
const slider = document.querySelector('.slider-home-page__slider');
let minSwipeDistance = 50; // Минимальное расстояние для срабатывания свайпа

function checkSwipeDirection() {
  if (Math.abs(touchendX - touchstartX) > minSwipeDistance) {
    if (touchendX < touchstartX) showSlide(currentSlideGridHomeSlider + 1); // Вправо
    if (touchendX > touchstartX) showSlide(currentSlideGridHomeSlider - 1); // Влево
  }
}

slider.addEventListener('touchstart', e => {
  touchstartX = e.changedTouches[0].screenX;
}, false);

slider.addEventListener('touchend', e => {
  touchendX = e.changedTouches[0].screenX;
  checkSwipeDirection();
}, false);

// Функция для обновления активных точек (dots)
function updateDots(index) {
  let dots = document.querySelectorAll('.dot');
  for (let i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" active", "");
  }
  dots[index].className += " active";
}